/**
 * VariantLabel - Display variant information for cart/checkout/booking items
 *
 * Shows variant details like "Small (250ml)", "Red", etc.
 */

import React from "react";

const VariantLabel = ({ item, showIcon = true }) => {
  if (!item) return null;

  const variantLabel = item.variantLabel || item.variantKey || "Default";
  
  // Check if this is actually a variant (not default)
  const hasVariant = variantLabel && variantLabel !== "default" && variantLabel !== "Default";

  if (!hasVariant) {
    return null;
  }

  return (
    <div
      style={{
        display: "inline-block",
        padding: "2px 8px",
        background: "#f0f9ff",
        border: "1px solid #bfdbfe",
        borderRadius: "4px",
        fontSize: "12px",
        color: "#1e40af",
        fontWeight: "500",
        marginTop: "4px",
      }}
    >
      {showIcon && "✓ "}
      {variantLabel}
    </div>
  );
};

export default VariantLabel;
